module.exports = __webpack_public_path__ + "img/vessel-dark-arrow.f57c18a4.svg";